import { RollbackOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';

import { usePutRequest } from 'hooks';

import { Transaction } from 'codegen';

export const BackOutTransaction = ({
  snapId,
  status,
  statusCode,
  transactionId,
}: {
  snapId?: number;
  status?: Transaction.status,
  statusCode?: number;
  transactionId?: number;
}) => {
  const [backOutTransaction, { loading }] = usePutRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}/backout`,
    options: {
      onSuccess: () => window.location.reload(),
    },
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;
  const showSendBtn = statusCode && statusCode !== 500;

  if (!showSendBtn || isBackedOut) {
    return null;
  }

  return (
    <Popconfirm
      title={(
        <div className='w-[250px]'>
          After back out all miles for this transaction will be deleted from collector account. Are you sure to back out?
        </div>
      )}
      onConfirm={() => backOutTransaction()}
    >
      <Button
        type='text'
        icon={<RollbackOutlined title='Back Out' className='text-[#ff4d4f]' />}
        loading={loading}
      />
    </Popconfirm>
  );
};
